
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  props: {
    keyValue: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    required:{
      type: Boolean,
      required: false,
    },
    value: {
      type: Boolean,
      required: false
    }
  },
  setup(props, { emit }) {
    const checked = ref(props.value);

    watch(() => props.value, (newValue) => {
      checked.value = newValue;
    });

    const updateValue = () => {
      emit('update', { key: props.keyValue || props.label, value: checked.value });
    };

    return {
      checked,
      updateValue
    };
  }
});
